import includes from 'lodash/includes'
import get from 'lodash/get'
import forOwn from 'lodash/forOwn'
import { ApolloClient, InMemoryCache, ApolloLink, split } from '@apollo/client'
import { HttpLink } from '@apollo/client/link/http'
import { onError } from '@apollo/client/link/error'

import { createUploadLink } from 'apollo-upload-client'
import { getWindow, jsonTryParse } from '@ztechapps/common.utils'
import isEmpty from 'lodash/isEmpty'

//routesDef.LoginPage.altPath

//when the operation name is one of the whitelisted, then it should be the http link
const hasNoUserContextOperation = ({ operationName }: { operationName: string }): boolean => {
  const whiteListOperationName = ['login', 'logout', 'fileUpload']
  return !includes(whiteListOperationName, operationName)
}

const httpErrorLink = (loginPath: string) =>
  onError(({ graphQLErrors, response, networkError }) => {
    if (graphQLErrors) {
      let errorMessage = get(graphQLErrors, '[0].message')
      errorMessage = jsonTryParse(errorMessage)
      errorMessage = get(errorMessage, '[0]')

      let isValidationError = false
      forOwn(errorMessage, (value, key) => {
        if (key === 'validationError') {
          isValidationError = true
        }
      })

      if (isValidationError && response) {
        response.errors = errorMessage as never
      }
    } else if (networkError) {
      const statusCode = get(networkError, 'statusCode')

      //just navigate out when authentication error
      if (statusCode === 401) {
        //navigate to log out when there is authentication errors
        globalThis.window.location?.replace(loginPath)
      }
    }
  })

export const setupApolloClient = (
  loginPath: string,
  accessToken?: string,
  uri?: string,
  hasNoUserContextOperationFunc = hasNoUserContextOperation
) => {
  const win = getWindow()
  uri = uri ?? `/graphql?tenantId=DFT`
  accessToken = accessToken ?? win?.localStorage?.getItem('app-login-token') ?? ''

  let cache = new InMemoryCache()

  const apolloState = jsonTryParse(win?.__APOLLO_STATE__) //this can be empty object on node
  if (!isEmpty(apolloState)) {
    cache = new InMemoryCache().restore(apolloState)
  }

  //create the http middleware
  const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers, accessing the local storage should be here so it will be executed
    //everytime there is a need for context
    operation.setContext({
      headers: {
        'totalmilk-login-token': accessToken,
      },
    })
    return forward(operation)
  })

  //create the http link
  const httpLink = new HttpLink({ uri })
  const uploadLink = createUploadLink({ uri })

  //create the error link for the http only

  const transportLink = split(hasNoUserContextOperationFunc, httpLink, uploadLink)
  const authHttpLink = ApolloLink.from([authMiddleware, httpErrorLink(loginPath), transportLink])

  return new ApolloClient({
    link: authHttpLink,
    cache,
    ssrForceFetchDelay: 100,
  })
}
